import { takeEvery, put, call } from 'redux-saga/effects';
import { GET_SHIPPING_DATA, GET_MOSCOW_DATA, ADD_COUNTRIES, ADD_PRICE, ADD_TAX_PRICE } from './actionTypes';
import {
  getShippingDataSuccess,
  getShippingDataFail,
  getMoscowDataSuccess,
  getMoscowDataFail,
  addPriceSuccess,
  addPriceFail,
  addTaxPriceSuccess,
  addTaxPriceFail,
  showLoading,
  hideLoading
} from './actions';
import { getShippingData, getMoscowData, addCountries, addCountryTr, addPrice, addTaxPrice } from '../../helpers/backend_helper';

function* fetchShippingData() {
  try {
    yield put(showLoading(true));
    const response = yield call(getShippingData);
    yield put(getShippingDataSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getShippingDataFail(error));
  }
}
function* fetchMoscowData() {
  try {
    yield put(showLoading(true));
    const response = yield call(getMoscowData);
    yield put(getMoscowDataSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getMoscowDataFail(error));
  }
}

function* onImportCountries({ payload: countries }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addCountries, countries);
    // const response = yield call(addCountriesTr, countries)
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
  }
}

function* onAddPrice({ payload: prices }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addPrice, prices);
    yield put(addPriceSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(addPriceFail(error));
  }
}

function* onAddTaxPrice({ payload: tax_prices }) {
  try {
    yield put(showLoading(true));
    const response = yield call(addTaxPrice, tax_prices);
    yield put(addTaxPriceSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(addTaxPriceFail(error));
  }
}

function* calculatorSaga() {
  yield takeEvery(GET_SHIPPING_DATA, fetchShippingData);
  yield takeEvery(GET_MOSCOW_DATA, fetchMoscowData);
  yield takeEvery(ADD_COUNTRIES, onImportCountries);
  yield takeEvery(ADD_PRICE, onAddPrice);
  yield takeEvery(ADD_TAX_PRICE, onAddTaxPrice);
}

export default calculatorSaga;
